export const clusterLayer = {
    id: 'clusters',
    type: 'circle',
    source: 'communities',
    filter: ['has', 'point_count'],
    paint: {
        'circle-color': [
            'step',
            ['get', 'point_count'],
            '#7B7B7B',
            100,
            '#7B7B7B',
            750,
            '#7B7B7B',
        ],
        'circle-radius': 14,
    },
};
export const clusterCountLayer = {
    id: 'cluster-count',
    type: 'symbol',
    source: 'communities',
    filter: ['has', 'point_count'],
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
    },
    paint: {
        'text-color': '#fff',
    },
};
export const createUnclusteredPointLayer = (theme) => ({
    id: 'unclustered-point',
    type: 'symbol',
    source: 'communities',
    filter: ['!', ['has', 'point_count']],
    layout: {
        'icon-image': 'map-pin',
        'icon-size': 0.17,
    },
    paint: {
        'icon-color': [
            'case',
            ['boolean', ['feature-state', 'active'], false],
            theme.palette.primary.main,
            '#707070',
        ],
    },
});
